import axios from "axios";
import { useAuthStore } from "@/store/auth";

export const API_BASE_URL =
  import.meta.env?.VITE_API_URL || "http://localhost:3001";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;

  // Always set Accept header
  config.headers["Accept"] = "application/json";

  // Set Content-Type for POST, PUT, PATCH requests
  if (["post", "put", "patch"].includes(config.method?.toLowerCase() || "")) {
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
    // Ensure POST requests have a body, even if empty
    if (!config.data && config.method?.toLowerCase() === "post") {
      config.data = {};
    }
  }

  // Set Authorization header if token exists
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});

export default api;
